import { render, staticRenderFns } from "./AbkOfferSalaryBox.vue?vue&type=template&id=04aade48&scoped=true&"
import script from "./AbkOfferSalaryBox.vue?vue&type=script&lang=js&"
export * from "./AbkOfferSalaryBox.vue?vue&type=script&lang=js&"
import style0 from "./AbkOfferSalaryBox.vue?vue&type=style&index=0&id=04aade48&scoped=true&lang=scss&"
import style1 from "./AbkOfferSalaryBox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04aade48",
  null
  
)

export default component.exports